import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmUserProfileForHubs = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "csm-hub-user-profile" */ './csm-hub-variants'),
	),
});
